import axios from "./axios.js";


export function getVerifyCode(data) {
  return axios.get("/activity/elevengroup/getVerifyCode", {
    params: data
  });
}

export function bindPhone(data) {
  return axios.post("/activity/elevengroup/bindPhone", data);
}

